import v from 'validate.js';

export default function validate(value, constraints, dependencies = null) {
  const errors = v.single(value, constraints);

  if (errors) {
    return errors[0];
  } else {
    return null;
  }
}

